import "./custom-popup.less";

export class CustomPopup {
	/**
	 * @position latlng object
	 * @content reference to div to make custom popup in
	 */

	constructor(content) {
		this.content = content;
		this.content.classList.add("popup-bubble");
		// This zero-height div is positioned at the bottom of the bubble.
		const bubbleAnchor = document.createElement("div");
		bubbleAnchor.classList.add("popup-bubble-anchor");
		bubbleAnchor.appendChild(content);
		// This zero-height div is positioned at the bottom of the tip.
		this.containerDiv = document.createElement("div");
		this.containerDiv.classList.add("popup-container");
		this.containerDiv.appendChild(bubbleAnchor);
	}

	setPosition(pos) {
		this.position = pos;
		this.draw();
	}

	/** Called when the popup is added to the map. */
	onAdd() {
		this.getPanes().floatPane.appendChild(this.containerDiv);
	}

	/** Called when the popup is removed from the map. */
	onRemove() {
		if(this.containerDiv.parentElement) {
			this.containerDiv.parentElement.removeChild(this.containerDiv);
		}
	}

	/** Called each frame when the popup needs to draw itself. */
	draw() {
		if(!this.position) {
			this.containerDiv.style.display = "none";
			return;
		}

		const divPosition = this.getProjection()?.fromLatLngToDivPixel(
			this.position
		);
		if(divPosition) {
		// Hide the popup when it is far out of view.
			const display =
			Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ?
				"block" :
				"none";

			if(display === "block") {
				this.containerDiv.style.left = divPosition.x + "px";
				this.containerDiv.style.top = divPosition.y + "px";
			}

			if(this.containerDiv.style.display !== display) {
				this.containerDiv.style.display = display;
			}
		}
	}

	/**
	 * 
	 * @html content that is put in popup 
	 */
	setText(html) {
		this.content.innerHTML = html;
	}

	/**
	 * deletes the content of the popup
	 */
	clearText() {
		while(this.content.firstChild) this.content.removeChild(this.content.firstChild);
	}
}
